import {createSlice, isAnyOf, type SliceSelectors} from '@reduxjs/toolkit'

import {restoreSavedState, restoreState} from '@web/actions/restoreState'
import {getInitialState, BranchState} from '@web/slices/branch/slice'

import type {BranchReducers, MakeCreateSliceOptions} from './interfaces'

export default (options?: MakeCreateSliceOptions) =>
    createSlice<BranchState, BranchReducers, 'branch', SliceSelectors<BranchState>>({
        name: 'branch',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            options?.extraReducers?.(builder)
            builder.addMatcher(isAnyOf(restoreSavedState.fulfilled, restoreState), (state, {payload}) => {
                return payload.branch ?? state
            })
        },
    })
